import { Tab } from '@common/ui-components';
import { ReactElement } from 'react';

import { TabsHeaderProps } from './tabs-header.types';

export default function TabsHeader({
  items = [],
}: TabsHeaderProps): ReactElement {
  return (
    <>
      {items.map((item) => (
        <Tab key={item.label}>{item.label}</Tab>
      ))}
    </>
  );
}
